import { memo, Suspense } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { clx } from 'Utils';
import { useResponsive, usePartnerDetails } from 'Hooks';
import {
	LoadingContent,
	SystemErrorAlert,
	PartnerDecorationBox
} from 'Elements';
import styles from 'partials/page/form.module.scss';

export const DetailPartner = memo(() => {
	const { partner_id } = useParams();
	const { isDesktopAndBelow } = useResponsive();

	const {
		data: fields,
		isFetching,
		isError
	} = usePartnerDetails(partner_id as string);

	return (
		<div className={clx(isDesktopAndBelow && styles.form)}>
			<PartnerDecorationBox />
			<Suspense fallback={<LoadingContent />}>
				<div className="position-relative">
					<Outlet context={fields} />
					{isFetching && <LoadingContent />}
					{isError && <SystemErrorAlert />}
				</div>
			</Suspense>
		</div>
	);
});

DetailPartner.displayName = 'DetailPartner';
